import React from "react";
import FindingsBySeverityChart from "../TableCharts/FindingsBySeverity/FindingsBySeverityChart";
import useWidgetFilterNavigator from "../../useWidgetFilterNavigator";
import type { ScopeSummaryItem } from "./useScopesGraph";
import type { CountBySeverity } from "../TableCharts/TopFeatureTables/TopFeatureTable";

export interface ScopeFindingsBySeverityProps {
  findingCounts: ScopeSummaryItem["count_per_severity"];
  totalCount?: number;
  maxFindings: number;
  scopeId: string | undefined;
  loading: boolean;
  widgetId: string;
  filterToExecute?: string;
  isForExport: boolean;
}

const ScopeFindingsBySeverity: React.FC<ScopeFindingsBySeverityProps> = ({
  findingCounts,
  totalCount,
  maxFindings,
  scopeId,
  loading,
  widgetId,
  filterToExecute,
  isForExport,
}) => {
  const { onFilterClick } = useWidgetFilterNavigator({
    filterToExecute,
    filterId: null,
    scopeToExecute: null,
    scopeId,
  });

  const onChartClick = (severity?: string) => {
    onFilterClick([["in", "remediation_item.severity", severity as string]]);
  };

  return (
    <FindingsBySeverityChart
      findingCounts={findingCounts as CountBySeverity | undefined}
      totalCount={totalCount}
      maxFindings={maxFindings}
      namePrefix={scopeId as string}
      loading={loading}
      widgetId={widgetId}
      isForExport={isForExport}
      onChartClick={onChartClick}
    />
  );
};

export default ScopeFindingsBySeverity;
